// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import queryString from 'query-string';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Search from '../../components/Search';
import { clearSearchSuggestions, getSearchSuggestions } from "../../actions/searchSuggestionsActions";
import SearchSuggestionsMenu from '../../components/SearchSuggestionsMenu';

const style = () => ({
    root: {
        backgroundColor: 'white',
    },
    backButton: {
        marginLeft: -12,
        marginRight: 20,
    },
});

type SearchAppBarStyleClasses = {
    root: string,
    backButton: string,
};

type Location = {
    search: string,
};

type History = {
    push: Function,
};

type Props = {
    dispatch: Function,
    show: boolean,
    onDismissClick: Function,
    location: Location,
    history: History,
    classes: SearchAppBarStyleClasses,
    suggestions: Array<any>,
};

class SearchAppBar extends Component<Props> {
    static defaultProps = {
        show: false,
    };

    constructor(props) {
        super(props);

        this.handleOnSearch = this.handleOnSearch.bind(this);
    }

    handleOnSearch = (value: string) => {
        this.props.history.push(`/searchorders?q=${value}`);
        this.props.dispatch(clearSearchSuggestions());
    };

    handleOnChange = async (value: string): Promise<void> => {
        await this.props.dispatch(getSearchSuggestions('sketchorders', value, 'address'));
    };

    handleOnSuggestionClick = (suggestionId: string) => {
        this.props.history.push(`/orders/${suggestionId}`);
        this.props.dispatch(clearSearchSuggestions());
    };

    render() { 
        const queryParams: Object = queryString.parse(this.props.location.search);
        const value: string = queryParams.q;
        return (
            !this.props.show ? (
                null
            ) : (
                <div>
                    <AppBar position="fixed" className={this.props.classes.root}>
                        <Toolbar>
                            <IconButton
                                onClick={this.props.onDismissClick}
                                className={this.props.classes.backButton}
                            >
                                <ArrowBackIcon />
                            </IconButton>

                            <Search
                                onSearch={this.handleOnSearch}
                                onChange={this.handleOnChange}
                                elevation={0}
                                fullWidth
                                autoFocus
                                defaultValue={value}
                            />
                        </Toolbar>

                        <SearchSuggestionsMenu
                            suggestions={this.props.suggestions}
                            onSuggestionClick={this.handleOnSuggestionClick}
                        />
                    </AppBar>
                </div>
            )
        );
    }
}

const mapStateToProps = (state) => {
    const { searchSuggestions: searchSuggestionsStore } = state;
    const { suggestions } = searchSuggestionsStore;
    return {
        suggestions,
    }
};
 
export default connect(mapStateToProps)(withRouter(withStyles(style)(SearchAppBar)));